/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description Kidney progress card
 */

// Dependencies
import { useTranslation } from 'react-i18next';
import { AreaChartOutlined } from '@ant-design/icons';

import DashboardPatientCard from '../dashboardPatientCard';

const KidneyProgressCard = () => {
  const { t: translate } = useTranslation();

  const data = {
    title: translate('dashboardPatient.kidneyProgressTitle'),
    link: 'kidney-progression',
    mainIcon: <AreaChartOutlined style={{ fontSize: 40, color: 'white' }} />,
    background: 'bg-cardOrange'
  };

  return <DashboardPatientCard data={data} />;
};

export default KidneyProgressCard;
